import React, { forwardRef, memo } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const IconBold = memo(
  forwardRef((props, ref) => (
    <SvgIcon
      {...props}
      ref={ref}
      viewBox="0 0 24 24"
      data-fill-none
    >
      <path
        d="M9 7V11.3784H11.5872C12.7963 11.3784 13.7764 10.3983 13.7764 9.1892C13.7764 7.98014 12.7963 7 11.5872 7H9Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 11.3779V16.5524H11.9853C13.4142 16.5524 14.5725 15.394 14.5725 13.9652C14.5725 12.5363 13.4142 11.3779 11.9853 11.3779H9Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  ))
);

IconBold.displayName = 'IconBold';
